import Page from "src/components/Report/Page";

export default function Page3t() {

    const SingleIndex = ({ title, isMain }) => {
        return (
            <div className="flex w-full items-center gap-10">
                <span className={`whitespace-nowrap ${isMain ? "font-bold" : null}`}>
                    {title}
                </span>
                <div className={`w-full  ${isMain ? "h-[2px] bg-gray-700" : "h-[1px] bg-black"}`}></div>
            </div>
        )
    }

    return (
        <Page isInnerPage={true} pageNumber={2}>
            <div className="flex flex-col gap-2 p-10">

                <SingleIndex title="اطلاعات پایه‌ای و ویژگی‌های شغل" isMain={true} />
                <SingleIndex title="شرح وظایف عمومی شغل" />
                <SingleIndex title="شرح وظایف تخصصی شغل" />

                {/* <SingleIndex title="ویژگی‌های شغل" isMain={true} /> */}
                <SingleIndex title="مسئولیت‌های شغلی" />
                <SingleIndex title="مخاطرات شغلی" />
                <SingleIndex title="دامنه‌های ارتباطی" />
                <SingleIndex title="ابزارها و تجهیزات مورد نیاز شغل" />

                {/* <SingleIndex title="شرایط احراز شغل" isMain={true} /> */}
                <SingleIndex title="شرایط احراز پایه" />
                <SingleIndex title="ویژگی‌های جسمی مورد نیاز" />
                <SingleIndex title="صلاحیت‌های حرفه‌ای شغل" />

                <SingleIndex title="مهارت‌ها و شایستگی‌های شغل" isMain={true} />
                <SingleIndex title="مهارت زبان‌های خارجی" />
                <SingleIndex title="مهارت‌های فناوری اطلاعات مورد نیاز" />
                <SingleIndex title="استانداردها و نظام‌های کیفیت مورد نیاز" />
                <SingleIndex title="قوانین و مقررات مورد نیاز" />

                {/* <SingleIndex title="شایستگی‌های شغل" isMain={true} /> */}
                <SingleIndex title="مدل شایستگی‌های عمومی شغل" />
                <SingleIndex title="شایستگی‌های عمومی شغل" />
                <SingleIndex title="مدل شایستگی‌های تخصصی شغل" />
                <SingleIndex title="شایستگی‌های تخصصی شغل" />

                <SingleIndex title="شاخص‌های ارزیابی عملکرد" isMain={true} />
                <SingleIndex title="شاخص های رفتاری (EVC)" />
                <SingleIndex title="شاخص های مبتنی بر شایستگی (KSA)" />
                <SingleIndex title="شاخص های عملکردی (PI)" />

                <SingleIndex title="ویژگی‌های روانشناسی شغل" isMain={true} />
                <SingleIndex title="علایق و رغبت شغلی" />
                <SingleIndex title="پنج ویژگی بارز رفتاری" />
                <SingleIndex title="هوش‌های چندگانه" />
                <SingleIndex title="نوع شخصیت مناسب شغل" />

                <SingleIndex title="گریدینگ شغل" isMain={true} />
                <SingleIndex title="گریدینگ شغل" />
                <SingleIndex title="نتیجه کلی ارزیابی ابعاد و مولفه‌های گریدینگ شغل" />
                <SingleIndex title="ضمائم" isMain={true} />
                <SingleIndex title="فرم جذب و استخدام (A)" />
                <SingleIndex title="فرم نیازسنجی آموزشی (B)" />
                <SingleIndex title="فرم ارزیابی عملکرد (C)" />
                <SingleIndex title="فرم ارتقا و جانشینی (D)" />


            </div>
        </Page>
    )
}